export default __webpack_public_path__ + "static/media/agustin_solari.b1ac527f.jpg";